<div class="dialog-header">
  <h2 mat-dialog-title>Nuevo consultorio</h2>
  <button mat-icon-button type="button" class="dialog-close" aria-label="Cerrar" [disabled]="busy()" (click)="dialogRef.close()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content class="new-business-dialog">
  <form class="new-business-form" [formGroup]="form" (ngSubmit)="create()">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Nombre del consultorio</mat-label>
      <input matInput type="text" formControlName="name" maxlength="100" autocomplete="off" cdkFocusInitial />
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Tu rol</mat-label>
      <mat-select formControlName="role">
        <mat-option value="doctor">Profesional de salud</mat-option>
        <mat-option value="admin">Administrador</mat-option>
      </mat-select>
      <mat-hint>
        Un administrador configura el consultorio, pero no registra pacientes, citas, consultas ni medicamentos.
      </mat-hint>
    </mat-form-field>

    @if (hasOtherBusinesses) {
      <div class="separation-notice" role="note">
        <mat-icon aria-hidden="true">shield</mat-icon>
        <div>
          <p class="separation-title">Este consultorio será completamente independiente.</p>
          <p>
            No se compartirá ninguna información con <strong>{{ existingNamesLabel }}</strong>.
            Pacientes, consultas, citas, medicamentos, plantillas, archivos y miembros se
            manejan por separado, y el plan y la facturación también son independientes.
          </p>
        </div>
      </div>
      <mat-checkbox formControlName="acknowledged">
        Entiendo que no se compartirán datos entre consultorios.
      </mat-checkbox>
    }

    <p class="plan-hint">El consultorio empieza en el plan Gratis. Podrás mejorarlo a Pro desde Consultorio.</p>

    @if (error()) {
      <p class="form-error" role="alert">{{ error() }}</p>
    }
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button type="button" [disabled]="busy()" (click)="dialogRef.close()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" [disabled]="formStatus() !== 'VALID' || busy()" (click)="create()">
    @if (busy()) {
      <mat-spinner diameter="18"></mat-spinner>
    } @else {
      Crear consultorio
    }
  </button>
</mat-dialog-actions>
